export default __webpack_public_path__ + "static/slide1-85da3a15374ad7592a07e4f4b63bb7d0.webp";